import { render, staticRenderFns } from "./ListWithShipments.vue?vue&type=template&id=5685cbb2"
import script from "./ListWithShipments.vue?vue&type=script&lang=js"
export * from "./ListWithShipments.vue?vue&type=script&lang=js"
import style0 from "./ListWithShipments.vue?vue&type=style&index=0&id=5685cbb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports